import * as actions from "./actions";

export default function autogiroTableActionsSubreducer(state, action) {
  switch (action.type) {
    case actions.AUTOGIRO_TABLE_COMPLETED_CHANGE_PAGE:
      return Object.assign({}, state, {
        autogiroCompleted: Object.assign({}, state.autogiroCompleted, {
          table: Object.assign({}, state.autogiroCompleted.table, {
            pagination: Object.assign(
              {},
              state.autogiroCompleted.table.pagination,
              {
                page: action.page,
              },
            ),
          }),
        }),
      });
    case actions.AUTOGIRO_TABLE_COMPLETED_CHANGE_FILTER:
      return Object.assign({}, state, {
        autogiroCompleted: Object.assign({}, state.autogiroCompleted, {
          table: Object.assign({}, state.autogiroCompleted.table, {
            currentFilter: Object.assign(
              {},
              state.autogiroCompleted.table.currentFilter,
              {
                ...action.filter,
              },
            ),
          }),
        }),
      });
    case actions.AUTOGIRO_TABLE_PENDING_CHANGE_PAGE:
      return Object.assign({}, state, {
        autogiroPending: Object.assign({}, state.autogiroPending, {
          table: Object.assign({}, state.autogiroPending.table, {
            pagination: Object.assign(
              {},
              state.autogiroPending.table.pagination,
              {
                page: action.page,
              },
            ),
          }),
        }),
      });
    case actions.AUTOGIRO_TABLE_PENDING_CHANGE_FILTER:
      return Object.assign({}, state, {
        autogiroPending: Object.assign({}, state.autogiroPending, {
          table: Object.assign({}, state.autogiroPending.table, {
            currentFilter: Object.assign(
              {},
              state.autogiroPending.table.currentFilter,
              {
                ...action.filter,
              },
            ),
          }),
        }),
      });
    default:
      return state;
  }
}
